import { bannerBox } from '../../../components/BannerBox/tokens/cobalt/ED';
import { deprecatedButton } from '../../../deprecated/Button/tokens/cobalt/';
import type { ComponentTokens } from '../types';
import { baseComponents } from './base';

export const components: ComponentTokens = {
  ...baseComponents,
  bannerBox,
  deprecatedButton,
};
